module.exports = __webpack_public_path__ + "img/thumb.c28032c8.png";